import { forwardRef, useImperativeHandle, useState } from "react";
import { DropDownMenu } from "@etframework/ui.components";
import { useBoardProvider } from "../../contexts/board/boardContext";

export const TaskBoardDropDown = forwardRef(
  ({ change, initialValue, id }, ref) => {
    const { boards } = useBoardProvider();

    const [boardId, setBoardId] = useState(initialValue);

    const getRuleDropdownOptions = () =>
      boards?.map((board) => {
        return {
          id: board.Id,
          text: board.Name,
          iconCss: board.Id == boardId ? "fa-solid fa-check" : "",
          onClick: () => {
            setBoardId(board.Id);
            change?.(board);
          },
        };
      });

    useImperativeHandle(ref, () => ({
      getValue: () => boards?.find((x) => x.Id === boardId),
    }));

    const handleRuleSelectMenuItem = (args) => {
      args?.onClick?.();
    };

    return (
      <DropDownMenu
        id={id}
        select={handleRuleSelectMenuItem}
        items={getRuleDropdownOptions()}
      >
        <div className="board-dd-title">
          {boards?.find((x) => x.Id === boardId)?.Name}
        </div>
      </DropDownMenu>
    );
  }
);
